module.exports = __webpack_public_path__ + "static/media/bigticket-details.0c6b492a.jpg";